import React, { Component } from "react";
import styled from "styled-components";
import { __, forceSatoshiFormat } from "../../../../Helper";
import storage from "../../../../Storage";

const TableContainer = styled.div`
  background: #1a1a1a;
  border-radius: 12px;
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
`;

const HandRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  background: ${(props) => (props.active ? "#2a2a2a" : "#222222")};
  border-radius: 8px;
  border-left: ${(props) =>
    props.active ? "4px solid #4CAF50" : "4px solid transparent"};
  transition: all 0.3s ease;

  &:hover {
    background: #2a2a2a;
  }
`;

const HandInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ColorDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${(props) => props.color};
`;

const HandName = styled.span`
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  font-family: "Arial", sans-serif;
`;

const PayoutInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Multiplier = styled.span`
  color: #ffffff;
  font-weight: bold;
  font-size: 14px;
  min-width: 40px;
`;

const Amount = styled.span`
  color: #4caf50;
  font-weight: 500;
  font-size: 14px;
  min-width: 60px;
  text-align: right;
`;

const IndianFlag = styled.span`
  &::before {
    content: "🇮🇳";
    margin-right: 4px;
  }
`;

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 0.0000001
      ),
      scoreName: null,
    };
  }

  componentDidMount() {
    this.props.engine.on("update_table", (score) => {
      this.setState({ scoreName: __.upperCase(score) });
    });

    this.props.engine.on("update_table_amount", (amount) => {
      this.setState({ amount: parseFloat(amount) });
    });
  }

  getHandColor = (handName) => {
    const colors = {
      "ROYAL FLUSH": "#E91E63",
      "STRAIGHT FLUSH": "#E91E63",
      "FOUR OF A KIND": "#FF9800",
      "FULL HOUSE": "#FF9800",
      FLUSH: "#FF5722",
      STRAIGHT: "#FF5722",
      "THREE OF A KIND": "#2196F3",
      "TWO PAIR": "#2196F3",
      "JACKS OR BETTER": "#2196F3",
      NOTHING: "#757575",
    };
    return colors[handName] || "#757575";
  };

  render() {
    const { scoreName, amount } = this.state;

    const hands = [
      { name: "ROYAL FLUSH", multiplier: "8x -", payout: amount * 8 },
      { name: "STRAIGHT FLUSH", multiplier: "4x -", payout: amount * 4 },
      { name: "FOUR OF A KIND", multiplier: "2x -", payout: amount * 2 },
      { name: "FULL HOUSE", multiplier: "1.9x -", payout: amount * 1.9 },
      { name: "FLUSH", multiplier: "1.6x -", payout: amount * 1.6 },
      { name: "STRAIGHT", multiplier: "1.4x -", payout: amount * 1.4 },
      { name: "THREE OF A KIND", multiplier: "1.3x -", payout: amount * 1.3 },
      { name: "TWO PAIR", multiplier: "1.2x -", payout: amount * 1.2 },
      { name: "JACKS OR BETTER", multiplier: "1.1x -", payout: amount * 1.1 },
      { name: "NOTHING", multiplier: "0x -", payout: 0 },
    ];

    return (
      <TableContainer>
        {hands.map((hand, index) => (
          <HandRow key={index} active={scoreName === hand.name}>
            <HandInfo>
              <ColorDot color={this.getHandColor(hand.name)} />
              <HandName>
                {hand.name === "FOUR OF A KIND"
                  ? "4 of a Kind"
                  : hand.name === "THREE OF A KIND"
                  ? "3 of a Kind"
                  : hand.name === "TWO PAIR"
                  ? "2 Pairs"
                  : hand.name === "JACKS OR BETTER"
                  ? "Jacks or Better"
                  : hand.name
                      .toLowerCase()
                      .replace(/\b\w/g, (l) => l.toUpperCase())}
              </HandName>
            </HandInfo>
            <PayoutInfo>
              <Multiplier>{hand.multiplier}</Multiplier>
              <Amount>
                <IndianFlag />₹{forceSatoshiFormat(hand.payout)}
              </Amount>
            </PayoutInfo>
          </HandRow>
        ))}
      </TableContainer>
    );
  }
}

export default Table;
